<template>
  <div class="school_manage">
    <div class="query_wapper">
      <div class="query_item">
        <el-upload
          :action="uploadUrl"
          accept=".xls"
          :show-file-list="false"
          withCredentials
          :on-success="handleUpload"
        >
          <el-button type="success">导入学校名单</el-button>
        </el-upload>
      </div>
      <div class="query_item">
        <el-button type="primary" @click="makeAccount" :loading="btnLoading">一键生成账号密码</el-button>
      </div>
      <!-- <div class="query_item">
        <el-button type="warning">清空重置</el-button>
      </div>-->
      <div class="query_item">
        <el-button style="width:90px" type="primary" @click="exportExcel">导出</el-button>
        <span class="excel_down" @click="templateDown">Excel模版下载</span>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="danger" @click="deletes">删除</el-button>
      </div>
    </div>
    <el-table
      border
      style="width:100%;margin-top:20px"
      :data="tableData"
      :cell-class-name="getCellIndex"
      ref="table"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" :reserve-selection="true" align="center" width="40"></el-table-column>
      <el-table-column label="序号" align="center" width="80">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>
      <el-table-column label="学校名称" width="200" align="center" prop="name">
        <template slot-scope="{row,column,$index}">
          <div
            style="display:flex;align-items:center;justify-content:center"
            @click.stop="{{changeNum($index,column,'editRemarkInput')}}"
          >
            <el-input
              v-if="editable[$index].name"
              v-model="row.name"
              size="mini"
              @blur="$event=>handleBlur($event,$index,column)"
              class="editRemarkInput"
            ></el-input>
            <el-button
              @click="updateTable($index)"
              style="padding:12px 5px;"
              type="success"
              v-if="editable[$index].name"
            >保存</el-button>
            <span v-else>{{row.name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="学校编号" align="center" prop="code">
        <template slot-scope="{row,column,$index}">
          <div
            style="display:flex;align-items:center;justify-content:center"
            @click.stop="{{changeNum($index,column,'editRemarkInput')}}"
          >
            <el-input
              v-if="editable[$index].code"
              v-model="row.code"
              size="mini"
              @blur="$event=>handleBlur($event,$index,column)"
              class="editRemarkInput"
            ></el-input>
            <el-button
              @click="updateTable($index)"
              style="padding:12px 5px;"
              type="success"
              v-if="editable[$index].code"
            >保存</el-button>
            <span v-else>{{row.code}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="注册管理" align="center" prop="registerName"></el-table-column>
      <el-table-column label="账号" align="center" prop="registerAccount"></el-table-column>
      <el-table-column label="密码" align="center" prop="registerPass">
        <template slot-scope="{row,column,$index}">
          <div
            style="display:flex;align-items:center;justify-content:center"
            @click.stop="{{changeNum($index,column,'editRemarkInput')}}"
          >
            <el-input
              v-if="editable[$index].registerPass"
              v-model="row.registerPass"
              size="mini"
              @blur="$event=>handleBlur($event,$index,column)"
              class="editRemarkInput"
            ></el-input>
            <el-button
              @click="updateTable($index)"
              style="padding:12px 5px;"
              type="success"
              v-if="editable[$index].registerPass"
            >保存</el-button>
            <span v-else>{{row.registerPass}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="学校审核" align="center" prop="examineName"></el-table-column>
      <el-table-column label="账号" align="center" prop="examineAccount"></el-table-column>
      <el-table-column label="密码" align="center" prop="examinePass">
        <template slot-scope="{row,column,$index}">
          <div
            style="display:flex;align-items:center;justify-content:center"
            @click.stop="{{changeNum($index,column,'editRemarkInput')}}"
          >
            <el-input
              v-if="editable[$index].examinePass"
              v-model="row.examinePass"
              size="mini"
              @blur="$event=>handleBlur($event,$index,column)"
              class="editRemarkInput"
            ></el-input>
            <el-button
              @click="updateTable($index)"
              style="padding:12px 5px;"
              type="success"
              v-if="editable[$index].examinePass"
            >保存</el-button>
            <span v-else>{{row.examinePass}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:40px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getMemberList)"
      @current-change="$event=>numberChange($event,this.getMemberList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      center
      :close-on-click-modal="false"
      title="删除"
      width="600px"
      :visible.sync="deleteModal"
    >
      <p style="font-size:18px;text-align:center;padding:20px">删除之后数据将不可恢复，是否继续？</p>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:90px;margin-right:40px" type="primary" @click="handleDelete">确 定</el-button>
        <el-button style="width:90px;" @click="deleteModal = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getSchoolMemberList,
  makeSchoolAccount,
  updateSchool,
  deleteSchools
} from "@/api/management-function";
import { table, message, page, dialog } from "@/common/js/mixins.js";
import { baseUrl } from "@/utils/config";
export default {
  mixins: [table, message, page, dialog],
  data() {
    return {
      query: {
        keyword: ""
      },
      // 表格多选数据
      multipleList: [],
      titles: ["name", "code", "registerPass", "examinePass"],
      editable: [],
      uploadUrl: baseUrl + "/member/addSchoolByExcel",
      btnLoading: false,
      saveItem: {} //表格修改列数据
    };
  },
  methods: {
    // 打开删除弹窗
    deletes() {
      if (this.multipleList.length == 0)
        return this.openWarn("请至少选择一条数据进行操作！");
      this.openDeleteDialog();
    },
    // 删除
    handleDelete() {
      let ids = this.multipleList
        .map(item => {
          return item.id;
        })
        .join(",");
      let currentPage =
        this.tableData.length === this.multipleList.length
          ? this.pageNo === 1
            ? this.pageNo
            : this.pageNo - 1
          : this.pageNo;
      deleteSchools({
        ids
      })
        .then(res => {
          this.openSuccess("删除成功！");
          this.closeDeleteDialog();
          this.getMemberList(currentPage);
          this.$refs.table.clearSelection();
        })
        .catch(err => {});
    },
    // 指定一个key标识这一行的数据
    getRowKey(row) {
      return row.id;
    },
    // 表格多选数据
    handleSelectionChange(val) {
      this.multipleList = val;
    },
    getCellIndex: function({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getMemberList();
    },
    // 导入模板
    handleUpload(data) {
      if (data.code === 200) {
        this.openSuccess("导入成功！");
        this.getMemberList();
      } else if (data.code === 500) this.openWarn(data.msg);
    },
    // 表格修改
    updateTable(index) {
      let { id, name, registerPass, examinePass, code } = this.saveItem;
      updateSchool({
        id,
        name,
        registerPass,
        examinePass,
        code
      })
        .then(res => {
          this.openSuccess("修改成功！");
          this.getMemberList();
        })
        .catch(err => {});
    },
    // 表格输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        this.editable[index][col.property] = false;
        this.saveItem = {};
      }, 200);
    },
    // 表格点击
    changeNum(index, row, className) {
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      this.editable[index][row.property] = true;
      this.saveItem = this.tableData[index];
      //让input自动获取焦点
      this.$nextTick(function() {
        var editInputList = document.getElementsByClassName(className);
        editInputList[0].children[0].focus();
      });
    },
    // 模板下载
    templateDown() {
      window.location.href = baseUrl + "/member/downloadSchoolDome";
    },
    // 导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }

      window.location.href =
        baseUrl + "/member/downloadSchoolList?" + params.join("&");
    },
    // 一键生成账号密码
    makeAccount() {
      this.btnLoading = true;
      makeSchoolAccount({})
        .then(res => {
          this.btnLoading = false;
          this.openSuccess("账号密码生成成功！");
          this.getMemberList();
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    // 数据列表
    getMemberList(currentPage = this.pageNo) {
      getSchoolMemberList({
        ...this.query,
        pageNo: currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
          res.list.filter(item => {
            let obj = {};
            this.titles.filter(temp => {
              obj[temp] = false;
            });
            this.editable.push(obj);
          });
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getMemberList();
  }
};
</script>
<style lang="less" scoped>
.school_manage {
  .excel_down {
    margin-left: 10px;
    font-size: 12px;
    color: rgb(22, 155, 213);
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>